import { useEffect, useState } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import PageContainer from "../../Components/Page/PageContainer";
import { TabMenu } from "primereact/tabmenu";
import { Card } from "primereact/card";
import NewIssuesBanner from "../../Components/NewIssuesBanner/NewIssuesBanner";

import { ROUTES } from "../../config/routes";

const MusicAssetAudits = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);

  // Sync active tab with current route
  useEffect(() => {
    const path = location.pathname;
    // Set active tab based on current route
    if (path.includes(ROUTES.YOUTUBE_MUSIC_ASSET_AUDITS_DASHBOARD)) {
      setActiveIndex(0);
    } else if (path.includes(ROUTES.MUSIC_LABEL_DASHBOARD)) {
      setActiveIndex(1);
    } else if (path.includes(ROUTES.MUSIC_VIDEO_EMBEDDING)) {
      setActiveIndex(2);
    } else if (path.includes(ROUTES.MUSIC_VIDEO_METADATA)) {
      setActiveIndex(3);
    } else if (path.includes(ROUTES.ASSET_TYPE_AUDIT)) {
      setActiveIndex(4);
    } else if (path.includes(ROUTES.STUB_ASSET_AUDIT)) {
      setActiveIndex(5);
    } else if (path.includes(ROUTES.MISMATCHED_SOUND_RECORDINGS)) {
      setActiveIndex(6);
    } else if (path.includes(ROUTES.MV_METADATA_GAPS)) {
      setActiveIndex(7);
    } else if (path.includes(ROUTES.BRAND_ARTIST_LOOKUP)) {
      setActiveIndex(8);
    } else if (path === ROUTES.YOUTUBE_MUSIC_ASSET_AUDITS) {
      setActiveIndex(0);
    } else {
      setActiveIndex(-1); // No tab selected for dashboard
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === ROUTES.YOUTUBE_MUSIC_ASSET_AUDITS) {
      navigate(ROUTES.YOUTUBE_MUSIC_ASSET_AUDITS_DASHBOARD, { replace: true });
    }
  }, [location.pathname, navigate]);

  const handleTabChange = (e: any) => {
    if (e.index === 0) {
      navigate(ROUTES.YOUTUBE_MUSIC_ASSET_AUDITS_DASHBOARD);
    } else if (e.index === 1) {
      navigate(ROUTES.MUSIC_LABEL_DASHBOARD);
    } else if (e.index === 2) {
      navigate(ROUTES.MUSIC_VIDEO_EMBEDDING);
    } else if (e.index === 3) {
      navigate(ROUTES.MUSIC_VIDEO_METADATA);
    } else if (e.index === 4) {
      navigate(ROUTES.ASSET_TYPE_AUDIT);
    } else if (e.index === 5) {
      navigate(ROUTES.STUB_ASSET_AUDIT);
    } else if (e.index === 6) {
      navigate(ROUTES.MISMATCHED_SOUND_RECORDINGS);
    } else if (e.index === 7) {
      navigate(ROUTES.MV_METADATA_GAPS);
    } else if (e.index === 8) {
      navigate(ROUTES.BRAND_ARTIST_LOOKUP);
    } else {
      navigate(ROUTES.YOUTUBE_MUSIC_ASSET_AUDITS_DASHBOARD);
    }
  };

  const items = [
    { label: "Dashboard", icon: "pi pi-home" },
    { label: "Music Label Dashboard", icon: "pi pi-chart-line" },
    { label: "Music Video Embedding ", icon: "pi pi-minus-circle" },
    { label: "Music Video Metadata ", icon: "pi pi-info-circle" },
    { label: "Asset Type ", icon: "pi pi-check-circle" },
    { label: "Stub Asset ", icon: "pi pi-file-excel" },
    { label: "SoundRecording Mismatch ", icon: "pi pi-exclamation-triangle" },
    { label: "MV Metadata Gaps", icon: "pi pi-pencil" },
    { label: "Brand → Artist Lookup", icon: "pi pi-list" },
  ];

  return (
    <>
      {/* Real-time notification banner */}
      <NewIssuesBanner
        collections={["SoundRecordingHealthMetrics", "MusicVideoHealthMetrics"]}
        position="top"
        showCount={true}
      />

      <PageContainer
        HomeMenuBarprops={{
          title: (
            <span
              style={{ cursor: "pointer", fontWeight: "bold" }}
              onClick={() => navigate(ROUTES.YOUTUBE_MUSIC_ASSET_AUDITS)}
            >
              YouTube: Music Asset Audits
            </span>
          ),
          // title: "YouTube: Music Asset Audits",

          Tabs: (
            <TabMenu
              activeIndex={activeIndex}
              onTabChange={handleTabChange}
              model={items}
            />
          ),
        }}
      >
        <div
          style={{
            width: "96%",
            margin: "0 auto",
          }}
        >
          <Card
            unstyled
            style={{
              marginTop: "2rem",
              boxShadow: "none",
            }}
          >
            {/* Use Outlet for sub-routes */}
            <Outlet />
          </Card>
        </div>
      </PageContainer>
    </>
  );
};

export default MusicAssetAudits;
